// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { string, boolean, number } from "@altostra/type-validations/lib/primitives";

export const isEngagementRemoteSegmentSearchResult = objectOf({
  segments: arrayOf(
    objectOf({
      id: string,
      name: string,
      app_group_id: string,
      is_archived: boolean,
      is_global_control: boolean,
      non_retargetable: boolean,
      estimated_size: number,
    })
  ),
  more: boolean,
});
